export default __webpack_public_path__ + "static/media/roseberry.0584ea06.jpeg";